<template>
  <div>
    <div class="row">
      <div class="col-md-12"></div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6 mb-3"><span
        class="is-bold ">{{ $t('leads.table.created_at') }}:</span> {{ selectedLead.created_at | localTime }}
      </div>
      <div v-if="selectedLead.phone" class="col-12 col-md-6 mb-3"><span
        class="is-bold ">{{ $t('references.inputs.mobile_phone') }}:</span> {{ selectedLead.phone }}
      </div>
      <div v-if="selectedLead.phone_2" class="col-12 col-md-6 mb-3"><span class="is-bold">{{
          $t('leads.details.phone')
        }}:</span> {{ selectedLead.phone_2 }}
      </div>
      <div class="col-12 col-md-6 mb-3"><span class="is-bold">Email:</span> {{ selectedLead.email || 'N/A' }}</div>
      <div
        v-if="selectedLead.address_line_1 || selectedLead.address_line_2 || selectedLead.address_city || selectedLead.address_door_number"
        class="col-12 col-md-6 mb-3">
        <span class="is-bold">{{ $t('leads.details.address') }}:</span>
        {{ selectedLead.address_line_1 }}<span
        v-if="selectedLead.address_line_1 && (selectedLead.address_line_2 || selectedLead.address_door_number)">, </span>
        {{ selectedLead.address_line_2 }}<span
        v-if="selectedLead.address_line_2 && (selectedLead.address_city || selectedLead.address_door_number)">, </span>
        {{ selectedLead.address_city }}<span
        v-if="selectedLead.address_city && selectedLead.address_door_number">, </span>
        {{ selectedLead.address_door_number }}<span
        v-if="selectedLead.address_postal_code">, </span>
        {{ selectedLead.address_postal_code }}
      </div>
      <div v-if="selectedLead.birthdate" class="col-12 col-md-6 mb-3"><span
        class="is-bold">{{ $t('leads.details.birthdate') }}: {{ birthdate }}</span></div>
      <div v-if="selectedLead.city" class="col-12 col-md-6 mb-3"><span
        class="is-bold">{{ $t('leads.details.city') }}:</span> {{ selectedLead.city }}
      </div>

      <div v-if="selectedLead.entity" class="col-12 col-md-6 mb-3"><span
        class="is-bold">{{ $t('leads.table.entity') }}:</span> {{ selectedLead.entity.name }}
      </div>
      <br/>
      <br/>
      <div v-if="selectedLead.privacy_policy" class="col-md-12">
            <span class="clickable" @click.prevent="$emit('openPrivacyPolicyModal', {})">
              <span class="clickable is-bold">{{ $t('leads.details.privacy_policy') }} </span>
              <i class="px-1 fa fa-external-link"></i>
            </span>
      </div>
    </div>

    <br>
    <div class="row">
      <div class="col-md-12" v-if="selectedLead.observations"><span
        class="is-bold">{{ $t('leads.details.observations') }}:</span> {{ selectedLead.observations }}
      </div>
    </div>

    <br/>

    &nbsp;
    <!-- Acuity -->
    <div >
      <h4> {{ $t('optometry.leads.acuity_test_results') }}</h4>
      <div v-if="selectedLead.acuity_result_left === null && selectedLead.acuity_result_right === null" class="row">
        <span>{{$t('optometry.labels.no_test_realized')}}</span>
      </div>
      <div v-else class="row">
        <div v-if="selectedLead.acuity_result_left" class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('optometry.leads.acuity_result_left') }}:</span> {{ selectedLead.acuity_result_left }}
          %
        </div>
        <div v-if="selectedLead.acuity_result_right" class="col-12 col-md-6 mb-3"><span
          class="is-bold">{{ $t('optometry.leads.acuity_result_right') }}:</span> {{ selectedLead.acuity_result_right }}
          %
        </div>
      </div>
    </div>

    &nbsp;
    <!-- Astigmatism -->
    <div>
      <h4> {{ $t('optometry.leads.astigmatism_test_results') }}</h4>
      <div v-if="selectedLead.astigmatism_result_left === null && selectedLead.astigmatism_result_right === null" class="row">
        <span>{{$t('optometry.labels.no_test_realized')}}</span>
      </div>
      <div v-else class="row">
        <div class="col-12 col-md-6 mb-3"><span class="is-bold ">{{ $t('optometry.leads.astigmatism_result_left') }}: &ensp; </span>
          <span v-if="selectedLead.astigmatism_result_left === null"> {{$t('optometry.labels.no_test_realized')}} </span>
          <i v-else
             :class="{'fa fa-check': selectedLead.astigmatism_result_left, 'fa fa-times': !selectedLead.astigmatism_result_left}"/>
        </div>
        <div class="col-12 col-md-6 mb-3"><span class="is-bold">{{ $t('optometry.leads.astigmatism_result_right') }}: &ensp; </span>
          <span v-if="selectedLead.astigmatism_result_right === null"> {{$t('optometry.labels.no_test_realized')}} </span>
          <i v-else
             :class="{'fa fa-check': selectedLead.astigmatism_result_right, 'fa fa-times': !selectedLead.astigmatism_result_right}"/>
        </div>
      </div>

    </div>

    &nbsp;
    <!-- Duochrome -->
    <div>
      <h4> {{ $t('optometry.leads.duochrome_test_results') }}</h4>
      <div v-if="selectedLead.duochrome_result === null" class="row">
        <span>{{$t('optometry.labels.no_test_realized')}}</span>
      </div>
      <div class="row" v-else>
        <div class="col-12 col-md-6 mb-3"><span class="is-bold ">{{ $t('optometry.leads.duochrome_test_results') }}: &ensp; </span>
          <span v-if="selectedLead.duochrome_result === null"> {{$t('optometry.labels.no_test_realized')}} </span>
          <i v-else
             :class="{'fa fa-check': selectedLead.duochrome_result, 'fa fa-times': !selectedLead.duochrome_result}"/>
        </div>
      </div>
    </div>

    &nbsp;
    <!-- Chromatic -->
    <div>
      <h4> {{ $t('optometry.leads.chromatic_test_results') }}</h4>
      <div v-if="selectedLead.chromatic_correct_answers === null && selectedLead.chromatic_wrong_answers === null" class="row">
        <span>{{$t('optometry.labels.no_test_realized')}}</span>
      </div>
      <div class="row" v-else>
        <div class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('optometry.leads.chromatic_correct_answers') }}:</span>
          {{$t('optometry.leads.chromatic_correct_answers_of_total', {correct: chromaticCorrectAnswersTotal, total: totalChromaticQuestions})}}
        </div>

      </div>
    </div>

    &nbsp;
    <!-- Contrast -->
    <div >
      <h4> {{ $t('optometry.leads.contrast_test_results') }}</h4>
      <div v-if="selectedLead.contrast_result_left === null && selectedLead.contrast_result_right === null" class="row">
        <span>{{$t('optometry.labels.no_test_realized')}}</span>
      </div>
      <div class="row" v-else>
        <div v-if="selectedLead.contrast_result_left" class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('optometry.leads.contrast_result_left') }}:</span>
          {{ selectedLead.contrast_result_left }} %
        </div>
        <div v-if="selectedLead.contrast_result_right" class="col-12 col-md-6 mb-3"><span
          class="is-bold">{{ $t('optometry.leads.contrast_result_right') }}:</span>
          {{ selectedLead.contrast_result_right }} %
        </div>
      </div>
    </div>

    &nbsp;
    <!-- Macular -->
    <div>
      <h4> {{ $t('optometry.leads.macular_test_results') }}</h4>
      <div v-if="selectedLead.macular_result_left === null && selectedLead.macular_result_right === null" class="row">
        <span>{{$t('optometry.labels.no_test_realized')}}</span>
      </div>
      <div class="row" v-else>
        <div class="col-12 col-md-6 mb-3"><span class="is-bold ">{{
            $t('optometry.leads.macular_result_left')
          }}: &ensp; </span>
          <span v-if="selectedLead.macular_result_left === null"> {{$t('optometry.labels.no_test_realized')}} </span>
          <i v-else :class="{'fa fa-check': selectedLead.macular_result_left, 'fa fa-times': !selectedLead.macular_result_left}"/>
        </div>
        <div class="col-12 col-md-6 mb-3"><span class="is-bold ">{{
            $t('optometry.leads.macular_result_right')
          }}: &ensp; </span>
          <span v-if="selectedLead.macular_result_right === null"> {{$t('optometry.labels.no_test_realized')}} </span>
          <i v-else :class="{'fa fa-check': selectedLead.macular_result_right, 'fa fa-times': !selectedLead.macular_result_right}"/>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import CurrentLocaleMixin from '@/mixins/CurrentLocaleMixin'

export default {
  props: {
    selectedLead: {
      type: Object,
      required: true
    },
  },
  mixins: [
    CurrentLocaleMixin
  ],
  data () {
    return {}
  },
  methods: {

  },
  computed: {
    chromaticCorrectAnswersTotal: function () {
      return Array.isArray(this.selectedLead.chromatic_correct_answers) ? this.selectedLead.chromatic_correct_answers.length : 0
    },
    totalChromaticQuestions: function () {
      return Array.isArray(this.selectedLead.chromatic_correct_answers) ? this.selectedLead.chromatic_correct_answers.length : 0 + Array.isArray(this.selectedLead.chromatic_wrong_answers) ? this.selectedLead.chromatic_wrong_answers.length : 0
    },
    birthdate: function () {
      if (this.isWebLead) {
        let created = this.moment(this.selectedLead.created_at, 'YYYY-MM-DD')
        let date = this.moment(this.selectedLead.birthdate, 'DD/MM/YYYY')
        let total = created.diff(date, 'years', true)
        let val = total < 18 ? '< 18' : total <= 29 ? '18 - 29' : total <= 49 ? '30 - 49' : total < 65 ? '50 - 65' : '> 65'
        return val
      }
      return this.selectedLead.birthdate
    },

    leadHeader: function () {
      let header = ''
      if (this.selectedLead && this.selectedLead.title && this.selectedLead.name && this.selectedLead.surname) {
        header = this.selectedLead.title + ' ' + this.selectedLead.name + ' ' + this.selectedLead.surname
      } else if (this.selectedLead && this.selectedLead.name && this.selectedLead.surname) {
        header = this.selectedLead.name + ' ' + this.selectedLead.surname
      } else if (this.selectedLead && this.selectedLead.name) {
        header = this.selectedLead.name
      }
      return header
    },
  }
}
</script>
